export default {
    lifts: 'mdi-elevator',
    fountains: 'mdi-fountain'
}